(function () {
  function sleep(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function normalizeName(value) {
    return String(value || '')
      .replace(/\u3000/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeHeader(value) {
    return String(value || '')
      .replace(/^\uFEFF/, '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\u4e00-\u9fa5]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function mapHeaderName(value) {
    var header = normalizeHeader(value);

    if (header === 'name' || header === 'names' || header === 'username' || header === 'full_name') return 'name';
    if (header === '姓名' || header === '名字' || header === '参与者' || header === '参与者姓名') return 'name';

    return header;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function csvToRows(text) {
    var cleaned = String(text || '').replace(/^\uFEFF/, '');
    var rows = [];
    var currentRow = [];
    var currentCell = '';
    var inQuotes = false;
    var index;

    for (index = 0; index < cleaned.length; index += 1) {
      var char = cleaned[index];
      var next = cleaned[index + 1];

      if (char === '"') {
        if (inQuotes && next === '"') {
          currentCell += '"';
          index += 1;
        } else {
          inQuotes = !inQuotes;
        }
      } else if (char === ',' && !inQuotes) {
        currentRow.push(currentCell);
        currentCell = '';
      } else if ((char === '\n' || char === '\r') && !inQuotes) {
        if (char === '\r' && next === '\n') {
          index += 1;
        }

        currentRow.push(currentCell);
        rows.push(currentRow);
        currentRow = [];
        currentCell = '';
      } else {
        currentCell += char;
      }
    }

    if (currentCell !== '' || currentRow.length) {
      currentRow.push(currentCell);
      rows.push(currentRow);
    }

    return rows.filter(function (row) {
      return row.some(function (cell) {
        return String(cell || '').trim() !== '';
      });
    });
  }

  function rowsToObjects(rows) {
    if (!rows.length) return [];

    var headers = rows[0].map(mapHeaderName);

    return rows.slice(1).map(function (row) {
      var data = {};

      headers.forEach(function (header, index) {
        data[header] = row[index] == null ? '' : String(row[index]).trim();
      });

      return data;
    });
  }

  function readFileAsText(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();

      reader.onload = function () {
        resolve(reader.result);
      };

      reader.onerror = function () {
        reject(new Error('Unable to read the file. Please upload it again.'));
      };

      reader.readAsText(file);
    });
  }

  function readFileAsArrayBuffer(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();

      reader.onload = function () {
        resolve(reader.result);
      };

      reader.onerror = function () {
        reject(new Error('Unable to read the file. Please upload it again.'));
      };

      reader.readAsArrayBuffer(file);
    });
  }

  async function parseSpreadsheetFile(file) {
    var fileName = String(file && file.name ? file.name : '').toLowerCase();

    if (fileName.endsWith('.csv')) {
      return rowsToObjects(csvToRows(await readFileAsText(file)));
    }

    if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) {
      if (typeof window.XLSX === 'undefined') {
        throw new Error('The Excel parser is still loading. Please try again in a moment, or upload CSV first.');
      }

      var workbook = window.XLSX.read(await readFileAsArrayBuffer(file), { type: 'array' });
      var sheetName = workbook.SheetNames[0];

      if (!sheetName) {
        throw new Error('The Excel file does not contain a readable sheet.');
      }

      return window.XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
        defval: '',
        raw: false
      }).map(function (row) {
        var normalized = {};

        Object.keys(row).forEach(function (key) {
          normalized[mapHeaderName(key)] = String(row[key] == null ? '' : row[key]).trim();
        });

        return normalized;
      });
    }

    throw new Error('Only CSV, XLSX, and XLS participant files are supported.');
  }

  function pickRandomSubset(list, count) {
    var copy = list.slice();
    var index;

    for (index = copy.length - 1; index > 0; index -= 1) {
      var randomIndex = Math.floor(Math.random() * (index + 1));
      var temp = copy[index];
      copy[index] = copy[randomIndex];
      copy[randomIndex] = temp;
    }

    return copy.slice(0, count);
  }

  function parseAssignedNames(text) {
    return String(text || '')
      .split(/\r?\n/)
      .map(function (name) {
        return normalizeName(name);
      })
      .filter(function (name) {
        return name !== '';
      });
  }

  function buildParticipants(rows) {
    var participants = [];
    var seenNames = new Set();
    var duplicateCount = 0;
    var invalidCount = 0;

    rows.forEach(function (row, index) {
      var rowNumber = index + 2;
      var values = Object.keys(row || {}).map(function (key) {
        return String(row[key] || '').trim();
      });
      var name = normalizeName(row.name || row[''] || values[0] || '');

      if (!values.some(function (value) { return value !== ''; })) {
        return;
      }

      if (!name) {
        invalidCount += 1;
        return;
      }

      if (seenNames.has(name)) {
        duplicateCount += 1;
        return;
      }

      seenNames.add(name);
      participants.push({
        id: 'participant-' + rowNumber,
        name: name,
        rowNumber: rowNumber
      });
    });

    return {
      participants: participants,
      stats: {
        validCount: participants.length,
        duplicateCount: duplicateCount,
        invalidCount: invalidCount,
        totalRows: rows.length
      }
    };
  }

  function validatePrizeConfig(prizes) {
    var issues = [];

    if (!prizes.length) {
      issues.push('Add at least one prize level in the section settings first.');
    }

    prizes.forEach(function (prize, index) {
      var assignedNames = parseAssignedNames(prize.assignedText);

      if (!prize.name) {
        issues.push('Prize level #' + (index + 1) + ' is missing a prize name.');
      }

      if (assignedNames.length > prize.winnerCount) {
        issues.push('The assigned names in "' + prize.name + '" exceed the configured winner count.');
      }
    });

    return issues;
  }

  function createDrawPlan(participants, prizes) {
    var totalSlots = prizes.reduce(function (sum, prize) {
      return sum + Number(prize.winnerCount || 0);
    }, 0);
    var selectedNames = new Set();
    var warnings = [];
    var ordered = [];

    if (!participants.length) {
      throw new Error('No valid participants were found in the uploaded file.');
    }

    if (totalSlots > participants.length) {
      throw new Error('The total winner count is larger than the valid participant count.');
    }

    prizes.forEach(function (prize) {
      var assignedNames = parseAssignedNames(prize.assignedText);
      var assignedWinners = [];
      var remainingPool;
      var randomWinners;
      var duplicateAssigned = new Set();

      assignedNames.forEach(function (name) {
        var participant = participants.find(function (item) {
          return item.name === name;
        });

        if (!participant) {
          warnings.push('The assigned name "' + name + '" in "' + prize.name + '" was not found in the uploaded file and was skipped.');
          return;
        }

        if (selectedNames.has(participant.name)) {
          warnings.push('The assigned name "' + participant.name + '" was already used in a higher prize and was skipped here.');
          return;
        }

        if (duplicateAssigned.has(participant.name)) {
          return;
        }

        duplicateAssigned.add(participant.name);
        assignedWinners.push(Object.assign({}, participant, { drawSource: 'assigned' }));
      });

      if (assignedWinners.length > prize.winnerCount) {
        assignedWinners = assignedWinners.slice(0, prize.winnerCount);
      }

      assignedWinners.forEach(function (winner) {
        selectedNames.add(winner.name);
      });

      remainingPool = participants.filter(function (participant) {
        return !selectedNames.has(participant.name);
      });

      if (remainingPool.length < prize.winnerCount - assignedWinners.length) {
        throw new Error('There are not enough remaining participants to complete "' + prize.name + '". Reduce assigned names or lower the winner count.');
      }

      randomWinners = pickRandomSubset(remainingPool, prize.winnerCount - assignedWinners.length).map(function (winner) {
        return Object.assign({}, winner, { drawSource: 'random' });
      });

      randomWinners.forEach(function (winner) {
        selectedNames.add(winner.name);
      });

      ordered.push({
        prize: prize,
        winners: assignedWinners.concat(randomWinners),
        stagePool: remainingPool.concat(assignedWinners),
        assignedCount: assignedWinners.length,
        randomCount: randomWinners.length
      });
    });

    return {
      ordered: ordered,
      warnings: warnings,
      totalSlots: totalSlots,
      participantCount: participants.length
    };
  }

  function createTemplateCsv() {
    return [
      'name',
      'Amy Chen',
      'Leo Wang',
      'Mia Lin',
      'Noah Xu'
    ].join('\n');
  }

  function createResultsCsv(plan) {
    var lines = ['prize_name,name'];

    plan.ordered.forEach(function (entry) {
      entry.winners.forEach(function (winner) {
        lines.push([
          entry.prize.name,
          winner.name
        ].map(function (value) {
          var text = String(value == null ? '' : value);
          return /[",\n]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
        }).join(','));
      });
    });

    return lines.join('\n');
  }

  function triggerDownload(fileName, content, mimeType) {
    var blob = new Blob([content], { type: mimeType });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');

    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.setTimeout(function () {
      URL.revokeObjectURL(url);
    }, 1000);
  }

  function initLuckyDraw(root) {
    if (!root || root.dataset.initialized === 'true') return;

    root.dataset.initialized = 'true';

    var configElement = root.querySelector('[data-lucky-draw-config]');
    var config = configElement ? JSON.parse(configElement.textContent) : null;
    var prizeIssues = validatePrizeConfig(config ? config.prizes : []);
    var cloudSlots = Array.from(root.querySelectorAll('[data-cloud-slot]'));
    var elements = {
      uploadInput: root.querySelector('[data-upload-input]'),
      uploadSurface: root.querySelector('[data-upload-surface]'),
      triggerUpload: root.querySelector('[data-trigger-upload]'),
      downloadTemplate: root.querySelector('[data-download-template]'),
      startDraw: root.querySelector('[data-start-draw]'),
      resetDraw: root.querySelector('[data-reset-draw]'),
      exportResults: root.querySelector('[data-export-results]'),
      status: root.querySelector('[data-status]'),
      revealBadge: root.querySelector('[data-reveal-badge]'),
      winnerGrid: root.querySelector('[data-winner-grid]'),
      confetti: root.querySelector('[data-confetti]')
    };
    var state = {
      participants: [],
      stats: null,
      plan: null,
      completed: false,
      running: false,
      token: 0,
      cloudInterval: null,
      confettiInstance: null,
      confettiCanvas: null
    };

    function clearCloudInterval() {
      if (state.cloudInterval) {
        window.clearInterval(state.cloudInterval);
        state.cloudInterval = null;
      }
    }

    function setStatus(type, text) {
      elements.status.className = 'lucky-draw__status lucky-draw__status--' + type;
      elements.status.textContent = text;
    }

    function getConfettiInstance() {
      if (
        state.confettiInstance &&
        state.confettiCanvas &&
        state.confettiCanvas.isConnected
      ) {
        return state.confettiInstance;
      }

      if (typeof window.confetti !== 'function' || !elements.confetti) {
        return null;
      }

      var canvas = document.createElement('canvas');

      canvas.className = 'lucky-draw__confetti-canvas';
      elements.confetti.innerHTML = '';
      elements.confetti.appendChild(canvas);
      state.confettiCanvas = canvas;
      state.confettiInstance = window.confetti.create(canvas, {
        resize: true,
        useWorker: true
      });

      return state.confettiInstance;
    }

    function updateButtons() {
      var ready = Boolean(state.plan && state.participants.length && !prizeIssues.length);

      elements.startDraw.disabled = !ready || state.running;
      elements.exportResults.disabled = !state.completed;
    }

    function renderCloud(names, highlightedName) {
      var safeNames = names.length ? names : ['Live draw', 'Lucky pick', 'Winner reveal'];

      cloudSlots.forEach(function (slot, index) {
        var name = safeNames[(index * 3 + Math.floor(Math.random() * safeNames.length)) % safeNames.length];
        slot.textContent = name;
        slot.classList.toggle('is-highlighted', highlightedName === name);
      });
    }

    function toTitleCase(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/\b([a-z])/g, function (match) {
          return match.toUpperCase();
        });
    }

    function setIdleCloud() {
      renderCloud(['Live draw', 'Golden spotlight', 'Lucky moment', 'Winner reveal', 'Prize night'], null);
    }

    function launchConfetti(color) {
      var fire = getConfettiInstance();

      if (typeof fire === 'function') {
        fire({
          particleCount: 120,
          spread: 72,
          startVelocity: 48,
          origin: { x: 0.18, y: 0.55 },
          colors: [color, '#ffd76d', '#ffffff', '#ff8a3d']
        });

        fire({
          particleCount: 120,
          spread: 72,
          startVelocity: 48,
          origin: { x: 0.82, y: 0.55 },
          colors: [color, '#ffd76d', '#ffffff', '#ff8a3d']
        });

        fire({
          particleCount: 70,
          spread: 110,
          startVelocity: 34,
          scalar: 1.08,
          origin: { x: 0.5, y: 0.28 },
          colors: [color, '#ffd76d', '#ffffff', '#ff8a3d']
        });
      }
    }

    function renderWinnerGrid(entry) {
      elements.revealBadge.textContent = toTitleCase(entry.prize.name);
      elements.winnerGrid.innerHTML = entry.winners.map(function (winner, index) {
        return [
          '<article class="lucky-draw__winner-card" style="--winner-delay: ' + (index * 100) + 'ms;">',
          '<h4>' + escapeHtml(winner.name) + '</h4>',
          '</article>'
        ].join('');
      }).join('');
    }

    function updateResultGroup(entry) {
      var group = root.querySelector('[data-prize-group="' + entry.prize.id + '"]');
      var list = group ? group.querySelector('[data-result-list]') : null;

      if (!list) return;

      list.innerHTML = entry.winners.map(function (winner) {
        return [
          '<li class="lucky-draw__result-item">',
          '<div>',
          '<strong>' + escapeHtml(winner.name) + '</strong>',
          '</div>',
          '</li>'
        ].join('');
      }).join('');
    }

    function resetResultGroups() {
      root.querySelectorAll('[data-result-list]').forEach(function (list) {
        list.innerHTML = '<li class="lucky-draw__result-empty">Waiting for reveal</li>';
      });
    }

    function clearStage() {
      clearCloudInterval();
      root.dataset.state = 'idle';
      elements.revealBadge.textContent = toTitleCase(config.stageIdlePrize);
      elements.winnerGrid.innerHTML = '';
      setIdleCloud();
    }

    async function runPrizeSequence(entry, token) {
      var stageNames = entry.stagePool.map(function (person) {
        return person.name;
      });
      if (token !== state.token) return false;

      root.dataset.state = 'rolling';
      elements.revealBadge.textContent = toTitleCase(entry.prize.name);
      elements.winnerGrid.innerHTML = '';

      state.cloudInterval = window.setInterval(function () {
        renderCloud(stageNames, null);
      }, 140);

      await sleep(Math.max(2600, Number(entry.prize.rollDuration || 5) * 1000));

      if (token !== state.token) return false;

      clearCloudInterval();

      renderCloud(stageNames, null);

      root.dataset.state = 'revealed';
      renderWinnerGrid(entry);
      updateResultGroup(entry);
      launchConfetti(entry.prize.color);

      await sleep(2200);
      return token === state.token;
    }

    async function startDraw() {
      var token;
      var index;

      if (!state.plan || state.running) return;

      state.token += 1;
      token = state.token;
      state.running = true;
      state.completed = false;

      updateButtons();
      resetResultGroups();
      clearStage();
      setStatus('info', 'The draw is in progress. Prize levels are being revealed one by one.');

      for (index = 0; index < state.plan.ordered.length; index += 1) {
        if (!(await runPrizeSequence(state.plan.ordered[index], token))) {
          state.running = false;
          updateButtons();
          return;
        }
      }

      if (token !== state.token) return;

      state.running = false;
      state.completed = true;
      root.dataset.state = 'complete';
      setStatus('success', 'All prize levels are complete. You can export the winners list now.');
      updateButtons();
    }

    async function handleFile(file) {
      var parsedRows;
      var processed;
      var plan;
      var summary;

      if (!file) return;

      setStatus('info', 'Reading file: ' + file.name);

      try {
        parsedRows = await parseSpreadsheetFile(file);
        processed = buildParticipants(parsedRows);
        plan = createDrawPlan(processed.participants, config.prizes);
        summary = 'Loaded ' + processed.stats.validCount + ' valid participants.';

        state.participants = processed.participants;
        state.stats = processed.stats;
        state.plan = plan;
        state.completed = false;

        if (plan.warnings.length) {
          setStatus('warning', summary + ' ' + plan.warnings[0]);
        } else {
          setStatus('success', summary + ' The stage is ready to start.');
        }

        clearStage();
      } catch (error) {
        state.participants = [];
        state.stats = null;
        state.plan = null;
        state.completed = false;
        clearStage();
        setStatus('error', error.message || 'The participant list could not be processed.');
      }

      updateButtons();
    }

    function resetDraw() {
      state.token += 1;
      state.running = false;
      state.completed = false;
      clearStage();
      resetResultGroups();
      updateButtons();

      if (state.plan) {
        setStatus('info', 'The stage has been reset. You can run the draw again with the current list.');
      } else if (!prizeIssues.length) {
        setStatus('info', 'Upload a participant file to validate names and prepare the live draw stage.');
      }
    }

    elements.triggerUpload.addEventListener('click', function () {
      elements.uploadInput.click();
    });

    elements.uploadInput.addEventListener('change', function (event) {
      var file = event.target.files && event.target.files[0];
      handleFile(file);
    });

    elements.uploadSurface.addEventListener('dragover', function (event) {
      event.preventDefault();
      elements.uploadSurface.classList.add('is-dragging');
    });

    elements.uploadSurface.addEventListener('dragleave', function () {
      elements.uploadSurface.classList.remove('is-dragging');
    });

    elements.uploadSurface.addEventListener('drop', function (event) {
      var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];

      event.preventDefault();
      elements.uploadSurface.classList.remove('is-dragging');

      if (file) {
        handleFile(file);
      }
    });

    elements.downloadTemplate.addEventListener('click', function () {
      triggerDownload('lucky-draw-template.csv', createTemplateCsv(), 'text/csv;charset=utf-8');
    });

    elements.exportResults.addEventListener('click', function () {
      if (!state.plan || !state.completed) return;
      triggerDownload('lucky-draw-results.csv', createResultsCsv(state.plan), 'text/csv;charset=utf-8');
    });

    elements.startDraw.addEventListener('click', startDraw);
    elements.resetDraw.addEventListener('click', resetDraw);

    clearStage();

    if (prizeIssues.length) {
      setStatus('error', prizeIssues[0]);
    } else {
      setStatus('info', 'Upload a participant file to validate names and prepare the live draw stage.');
    }

    updateButtons();
  }

  function initAllLuckyDrawSections(container) {
    (container || document).querySelectorAll('[data-lucky-draw]').forEach(initLuckyDraw);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllLuckyDrawSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllLuckyDrawSections(event.target);
  });
})();